/* ============================================================
 * AYU Datenschutzerklärung Page
 * AYU Healthtech LIMITED – 128 City Road, London, EC1V 2NX
 * ============================================================ */
import { IMAGES } from "@/lib/constants";
import { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: "oklch(0.97 0.005 80)" }}>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[oklch(0.97_0.005_80/0.95)] backdrop-blur-md shadow-sm py-3">
        <div className="container flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="AYU" className="h-10 w-auto" />
          </a>
          <a href="/" className="text-sm text-[oklch(0.52_0.09_128)] font-medium hover:underline" style={{ fontFamily: "var(--font-body)" }}>
            ← Zurück zur Startseite
          </a>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-28 pb-20">
        <div className="container max-w-3xl">
          <h1 className="text-3xl sm:text-4xl font-bold text-[oklch(0.2_0.02_80)] mb-8">
            Datenschutzerklärung
          </h1>

          <div className="space-y-8 text-[oklch(0.35_0.02_80)] leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">1. Verantwortlicher</h2>
              <p>
                AYU Healthtech LIMITED<br />
                128 City Road, London, United Kingdom, EC1V 2NX<br />
                E-Mail: <a href="mailto:office@ayu-rveda.ai" className="text-[oklch(0.52_0.09_128)] hover:underline">office@ayu-rveda.ai</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">2. Erhebung und Speicherung personenbezogener Daten</h2>
              <p className="mb-4">
                Beim Besuch unserer Website werden automatisch Informationen allgemeiner Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem, den Domainnamen Ihres Internet-Service-Providers, Ihre IP-Adresse und ähnliches.
              </p>
              <p>
                Sie werden insbesondere zu folgenden Zwecken verarbeitet: Sicherstellung eines problemlosen Verbindungsaufbaus der Website, Sicherstellung einer komfortablen Nutzung unserer Website, Auswertung der Systemsicherheit und -stabilität sowie zu weiteren administrativen Zwecken.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">3. Cookies</h2>
              <p className="mb-4">
                Wir verwenden auf unserer Seite sogenannte Cookies. Cookies sind kleine Textdateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite besuchen.
              </p>
              <p className="mb-4">
                Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann.
              </p>
              <p>
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">4. Analyse-Tools</h2>
              <p>
                Wir verwenden auf unserer Website Analyse-Tools zur statistischen Auswertung der Besucherzugriffe. Diese Daten werden anonymisiert erhoben und dienen ausschließlich der Verbesserung unseres Angebots. Es werden keine personenbezogenen Daten an Dritte weitergegeben.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">5. Kontaktformular und E-Mail-Kontakt</h2>
              <p>
                Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">6. Ihre Rechte</h2>
              <p className="mb-4">Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Recht auf Auskunft</li>
                <li>Recht auf Berichtigung oder Löschung</li>
                <li>Recht auf Einschränkung der Verarbeitung</li>
                <li>Recht auf Widerspruch gegen die Verarbeitung</li>
                <li>Recht auf Datenübertragbarkeit</li>
              </ul>
              <p className="mt-4">
                Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">7. Gesundheitsdaten</h2>
              <p>
                Im Rahmen der Nutzung unserer AYU-Dienste können gesundheitsbezogene Daten erhoben werden (z.B. Angaben zu Ernährung, Lebensstil, körperlichem Befinden). Diese Daten werden ausschließlich zur Erstellung Ihres personalisierten Gesundheitsplans verwendet und mit höchster Sorgfalt und unter Einhaltung aller geltenden Datenschutzbestimmungen verarbeitet. Eine Weitergabe an Dritte erfolgt nicht.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">8. Datensicherheit</h2>
              <p>
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schlüssel- beziehungsweise Schloss-Symbols in der unteren Statusleiste Ihres Browsers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">9. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand März 2026. Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-[oklch(0.9_0.01_80)]">
        <div className="container flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-[oklch(0.5_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
            © {new Date().getFullYear()} AYU Healthtech LIMITED. Alle Rechte vorbehalten.
          </span>
          <div className="flex items-center gap-6">
            <a href="/" className="text-xs text-[oklch(0.5_0.02_80)] hover:text-[oklch(0.52_0.09_128)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>Startseite</a>
            <a href="/impressum" className="text-xs text-[oklch(0.5_0.02_80)] hover:text-[oklch(0.52_0.09_128)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>Impressum</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
